export default "__VITE_ASSET__D6AC7hKg__"